export const ST_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Speech-Language Pathologist",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The speech-language pathologist is responsible for implementation of standards of care for speech language pathology services and for adherence to all conditions in the Service Agreement."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Conducts appropriate evaluations, assesses home environment (as appropriate), identifies equipment needs relative to speech/language function.",
            "Identifies functional speech defects and establishes a plan of care to improve patient's function.",
            "Administers speech therapy program utilizing specialized therapeutic technique and/or equipment.",
            "Recommends communication devices/aids as indicated.",
            "Confers with referring physician and other organization personnel to ensure coordinated and comprehensive care contributes to the total plan of care.",
            "As appropriate, participates in case conferences, inservices and other meetings required to ensure coordinated and comprehensive care.",
            "Prepares and submits notes per organization policy.",
            "Maintains clinical competency in speech language pathology practice and theory.",
            "Identifies patient and family/caregiver needs for other services and refers as appropriate.",
            "Instructs patient, family/caregiver and other Organization health care personnel in the patient's treatment regime as indicated.",
            "May supervise home health aide in procedures directly related to the speech-language therapy plan of care.",
            "Performs other duties as required to facilitate the delivery of speech language pathology services."
        ],
        generalStatement: "The above statements are only meant to be a representative summary of the major duties and responsibilities performed by incumbents of this job. The incumbents may be requested to perform job related tasks other than those stated in this description."
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Possesses a degree that includes an internship from an approved Master's program in Speech-Language Pathology, or as required by applicable law and/or regulation.",
            "Meets the education and experience requirements for a Certificate of Clinical Competence in Speech-Language Pathology, granted by the American Speech-Language-Hearing Association (ASHA).",
            "Is certified to practice Speech-Language Pathology.",
            "A minimum of one year's clinical experience in Speech-Language Pathology.",
            "Demonstrates good verbal and written communication, and organization skills.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const ST_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST—SPEECH THERAPIST",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Knowledge of Assessment Process:",
                items: [
                    "a. Health history and physical exam",
                    "b. Development of Problem List",
                    "c. Development and revision of care plan",
                    "d. Assesses response to treatment",
                    "e. Establishes and revises goals",
                    "f. DC planning",
                    "g. Conducts complete initial valuation",
                    "h. Other"
                ]
            },
            {
                category: "2. Documentation Skills: (accurate, legible, timely, and complete)",
                items: [
                    "a. 485, 486, 487",
                    "b. Progress notes, flow charts",
                    "c. Summary report",
                    "d. Incident/Variance reporting",
                    "e. Other"
                ]
            },
            {
                category: "3. Adheres to POC",
                items: [
                    "a. Reviews POC prior to care",
                    "b. Performs services as ordered",
                    "c. Documents according to POC",
                    "d. Communicates/coordinates if appropriate",
                    "e. Other"
                ]
            }
        ]
    },

    // Page 2: Administrative Continued
    {
        id: 2,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate: (continued)",
        competencies: [
            {
                category: "4. Knowledge of Medicare/State Guidelines:",
                items: [
                    "a. Criteria for participation",
                    "b. Skilled reimbursable visit",
                    "c. Skilled reimbursable visit",
                    "d. Other"
                ]
            },
            {
                category: "5. Reports and documents key information to Physician, DC Planner, Clinician, Pharmacist, Supervisor"
            },
            {
                category: "6. Participates as team member"
            },
            {
                category: "7. Submits written summary reports as indicated"
            },
            {
                category: "8. Attends/participates in case conference as required"
            },
            {
                category: "9. Supervision of Ancillary Personnel:",
                items: [
                    "a. PTA (Physical Therapist Assistant)",
                    "b. HHA (Home Health Aide)"
                ]
            },
            {
                category: "10. Supply/HME requisition and management"
            },
            {
                category: "11. Infection Control Practices:",
                items: [
                    "a. Hand washing",
                    "b. Personal protective equipment",
                    "c. Exposure control plan",
                    "d. Equipment care, as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "12. Patient home safety"
            },
            {
                category: "13. Other"
            }
        ]
    },

    // Page 3: Patient Education & Clinical Skills
    {
        id: 3,
        type: 'section',
        title: "B. Patient Education & Clinical Skills:",
        competencies: [
            {
                category: "B. Patient Education:",
                items: [
                    "1. Determines learning needs",
                    "2. Sets objectives",
                    "3. Develops/implement teaching plan",
                    "4. Evaluates effectiveness of teaching",
                    "5. Revises teaching plan",
                    "6. Documents patient response",
                    "7. Other"
                ]
            },
            {
                category: "C. Clinical Skills—General:",
                items: [
                    "1. Vital Signs/I&O (Intake and Output)",
                    "2. Other"
                ]
            }
        ]
    },

    // Page 4: Assessment and Evaluation
    {
        id: 4,
        type: 'section',
        title: "D. Assessment and Evaluation:",
        competencies: [
            {
                category: "D. Assessment and Evaluation:",
                items: [
                    "1. Cognition/communication",
                    "2. Musculoskeletal-Skeletal (ROM, posture, deformity)",
                    "3. Pain (location, intensity, relief)",
                    "4. Neuro-Muscular Function (motor control, strength, coordination, tone, reflexes)",
                    "5. Sensation",
                    "6. Endurance",
                    {
                        text: "7. Functional Findings:",
                        subItems: [
                            "a. Bed mobility",
                            "b. Gait",
                            "c. Transfers",
                            "d. Equipment management"
                        ]
                    },
                    "8. Environmental eval/architectural barriers",
                    "9. Other tests or measurements"
                ]
            }
        ]
    },

    // Page 5: Skilled Treatments/Interventions
    {
        id: 5,
        type: 'section',
        title: "E. Skilled Treatments/Interventions:",
        competencies: [
            {
                category: "E. Skilled Treatments/Interventions:",
                items: [
                    {
                        text: "1. Perform therapeutic exercises:",
                        subItems: [
                            "a. Active",
                            "b. Passive",
                            "c. Strengthening and endurance"
                        ]
                    },
                    "2. Transfer Activities",
                    {
                        text: "3. Mobilization:",
                        subItems: [
                            "a. Bed mobility",
                            "b. Gait training",
                            "c. Other"
                        ]
                    },
                    {
                        text: "4. Use of Physical agents:",
                        subItems: [
                            "a. Ultrasound",
                            "b. Hot/cold packs",
                            "c. TENS/FES",
                            "d. Massage",
                            "e. Other"
                        ]
                    },
                    {
                        text: "5. Prosthetic Training:",
                        subItems: [
                            "a. Care of prosthesis",
                            "b. Stump conditioning",
                            "c. Other"
                        ]
                    },
                    {
                        text: "6. Assistive Devices:",
                        subItems: [
                            "a. Fit/adjustment",
                            "b. Gait training",
                            "c. Safety",
                            "d. Other"
                        ]
                    },
                    "7. Fabricates orthotic device, instructs in use",
                    "8. Management and evaluation of the patients care plan",
                    "9. Other"
                ]
            }
        ]
    },

    // Page 6: Comments & Signatures
    {
        id: 6,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Clinician Signature", name: "clinicianSignature" },
            { label: "Date", name: "clinicianDate", inputType: "date" },
            { label: "Evaluator Signature", name: "evaluatorSignature" },
            { label: "Date", name: "evaluatorDate", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 7,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];